import React from 'react';
import './TitleAndImages.module.scss';

type Props = {
  attributes: any;
  inPopup?: boolean;
};

export default function TitleAndImages({ attributes, inPopup }: Props) {
  return (
    <div styleName={`title-and-images ${inPopup ? 'in-popup' : ''}`}>
      {attributes.image && (
        <div styleName="image-wrapper">
          <img alt="content" src={`/storage/${attributes.image}`} />
        </div>
      )}
      {attributes.image && (
        <div styleName="image-wrapper">
          <img alt="content" src={`/storage/${attributes.image}`} />
        </div>
      )}
      <h2>{attributes?.title}</h2>
    </div>
  );
}
